export const TYPES = {
  success: 'success',
  error: 'error',
  warning: 'warning',
}
